import { useVisitDialog } from "./DialogContext";
import successIcon from "../../../../assets/icons/successIcon.svg";
import HeadingDialog from "../../../../components/UI/viewDialogs/HeadingDialog";
import { VisitModalLayout } from "./VisitModalLayout";

VisitModalLayout.Header = function Header() {
  const { successView } = useVisitDialog();
  if (successView) {
    return (
      <>
        <img src={successIcon} alt="sucess" className="mx-auto mb-1 w-9" />
        <p className="view-success-msg-d">Visit Successfully Created!</p>
      </>
    );
  }

  return <HeadingDialog heading="Visit Details" />;
};
